import { gate } from 'hub-http/gates';

// scopes
export const INVOICE_CREATE_SCOPE = 'invoices-edit-owned';
export const SUBSCRIPTIONS_WRITE_SCOPE = 'subscriptions-write';
export const CRM_EDIT_ALL_DEALS_SCOPE = 'crm-edit-all-deals';
export const CRM_EDIT_TEAM_OWNED_DEALS = 'crm-edit-team-owned-deals';
export const CRM_EDIT_UNASSIGNED_DEALS = 'crm-edit-unassigned-deals';
export const CRM_EDIT_OWNED_DEALS = 'crm-edit-owned-deals';
export const QUOTE_CREATE_SCOPE = 'quote-create';
export const CPQ_QUOTE_ACCESS_SCOPE = 'cpq-quote-access';
export const CPQ_QUOTE_CREATE_SCOPE = 'cpq-quote-create';

// gates
export const SEAMLESS_SENDING_GATE = gate('CommerceGrowth:SeamlessSending');
export const QUOTE_APPROVALS_GATE = gate('ProductApprovals:Quotes');
export const CPQ_QUOTES_GATE = gate('commerce:cpq:bse:CPQQuote');
export const CPQ_QUOTES_DRAG_AND_DROP_TEMPLATE_GATE = gate('commerce:cpq:bse:dragAndDropTemplate');
export const CPQ_BLUEPRINTS_GATE = gate('commerce:cpq:bse:blueprints');
export const CPQ_QUOTE_TRACKING_M1_GATE = gate('Commerce:CPQ:QuoteTrackingM1');
export const SUMMARY_DASHBOARD_GATE = gate('Commerce:CPQ:QuotesSummaryM1');
export const AI_GENERATE_BUYER_EMAIL_GATE = gate('commerce:cpq:ai:BuyerEmail');
// Deprecated, use CLOSING_AGENT_GATE instead
export const DEAL_CLOSING_AGENT_GATE = gate('commerce:cpq:ai:DealClosingAgent');
export const CLOSING_AGENT_GATE = gate('commerce:cpq:ai:ClosingAgent');
export const ASSOCIATION_CARD_REDESIGN_GATE = gate('CRM:Record:AssociationCardRedesign');
export function hasSomeEditScopes(scopes) {
  return scopes.has(CRM_EDIT_ALL_DEALS_SCOPE) || scopes.has(CRM_EDIT_TEAM_OWNED_DEALS) || scopes.has(CRM_EDIT_UNASSIGNED_DEALS) || scopes.has(CRM_EDIT_OWNED_DEALS);
}